import axios from "axios";
import { base_URL } from "../config/config";

const API_BASE_URL = `${base_URL}/api/mobile/otp`;


/**
 * Send OTP to phone number
 * @param {string} to - Phone number in E.164 format (e.g., +971501234567)
 * @param {string} channel - Channel to send OTP (default: 'sms')
 */
export const sendOtpApi = async (to, channel = 'sms') => {
  try {
    const data = { to, channel };

    const response = await axios.post(`${API_BASE_URL}/send`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error sending OTP to mobile:", error);

    // Handle rate limiting
    if (error.response?.status === 429) {
      const retryAfter = error.response.data?.retryAfter || 900;
      const err = new Error(error.response.data?.error || `Too many attempts. Please wait ${retryAfter} seconds.`);
      err.status = 429;
      err.retryAfter = retryAfter;
      throw err;
    }

    // Handle session expiry
    if (error.response?.status === 403) {
      const err = new Error('Session expired. Please try again.');
      err.status = 403;
      throw err;
    }

    // Handle other errors
    const msg = error.response?.data?.error || error.message || 'Failed to send OTP';
    const err = new Error(msg);
    err.status = error.response?.status;
    throw err;
  }
};

/**
 * Verify OTP code
 *
 * @param {object} data - Object containing { to, code }
 *
 * NOTE: Session token is optional. Backend should primarily rely on:
 * 1. User's authentication token (if logged in)
 * 2. IP-based rate limiting
 * 3. Phone-number-based rate limiting
 */
export const verifyOtpApi = async (data) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await axios.post(`${API_BASE_URL}/check`, data, {
      headers,
    });

    return response.data;
  } catch (err) {
    console.error("Error verifying OTP:", err);

    // Handle rate limiting
    if (err.response?.status === 429) {
      const retryAfter = err.response.data?.retryAfter || 900;
      const error = new Error(err.response.data?.error || `Too many attempts. Please wait ${retryAfter} seconds.`);
      error.status = 429;
      error.retryAfter = retryAfter;
      throw error;
    }

    if (err.response?.status === 403) {
      const error = new Error('Session expired. Please try again.');
      error.status = 403;
      throw error;
    }

    // Handle other errors
    const msg =
      err.response?.data?.error ??
      (err.response?.status === 404
        ? "Service not found. Check API route."
        : null) ??
      "Could not verify the code.";
    const e = new Error(msg);
    e.status = err.response?.status;
    e.code = err.response?.data?.code;
    throw e;
  }
};
